<template>
  <div>
    <b-row class="mt-2 mb-2">
      <b-col cols="3">
        <b-form-group label="Report" label-for="selectReport" class="text-left">
          <b-form-select id="selectReport"
                         v-model="selectedReportIndex"
                         @change="onReportChanged"
                         :disabled="reports.length == 0">
            <option v-for="(report, index) in reports" :key="report.Id" :value="index">
              {{ report.Name }}
            </option>
          </b-form-select>
          <div style="padding-top:10px;" class="d-flex d-flex-row justify-content-between">
            <b-btn variant="primary" @click="runReport" :disabled="reports.length == 0" class="report-button">Run Report</b-btn>
            <b-btn variant="info" @click="exportToExcel" :disabled="reportData && reportData.length == 0" class="report-button">Export to Excel</b-btn>
          </div>
        </b-form-group>
      </b-col>
      <b-col cols="2">
        <parameters-table v-if="reports.length > 0" :list="reports[selectedReportIndex].Parameters" @changed="onParametersChanged"/>
      </b-col>
    </b-row>
    <report-table :data="reportData" :columnFormatters="columnFormatters"/>
  </div>
</template>

<script>
import ObjSpinnerState          from "@/components/common/spinner/ObjSpinnerState";
import service                  from '@/services/HttpRequestService';
import ParametersTable          from '@/components/common/parameterValuePicker/ParametersTable';
import ReportTable              from '@/components/reports/ReportTable';
import ExcelSupport             from "@/utilities/ExcelSupport";
import ReportColumnsCalculation from "@/utilities/ReportColumnsCalculation";
import ManagerRequest           from "@/services/ManagerRequest";
import formatter                from "@/utilities/Formatter";

export default {
  data() {
    return {
      selectedReportIndex:   0,
      reports:               [],
      reportData:            [],
      reportAsArrayOfArrays: [],
      columnFormatters:      [],
      ObjSpinnerState
    };
  },
  async created() {
    this.reports = await (new ManagerRequest(service.getReports, service, this.reports)).do();
  },
  methods:    {
    async onReportChanged(newReportIndex) {
      this.reportData            = [];
      this.reportAsArrayOfArrays = [];
      this.columnFormatters      = [];
    },
    async onParametersChanged(name, value) {
      this.reportData            = [];
      this.reportAsArrayOfArrays = [];
      this.columnFormatters      = [];
    },
    async exportToExcel() {
      const reportName = this.reports[this.selectedReportIndex].Name;
      let date         = new Date();
      date             = formatter.formatDateValue(date, 'MM-DD-YYYY HH-mm');
      const fileName   = `${reportName}-${date}.csv`;
      const sheetName  = `${reportName}`.substring(0, 30);
      const sheetData  = this.reportAsArrayOfArrays;
      const dataset    = [{sheetName: sheetName, sheetData: sheetData}];
      ExcelSupport.exportToXlsx(dataset, fileName);
    },
    async runReport() {
      let params            = this.reports[this.selectedReportIndex].Parameters;
      this.reportData       =
          await (new ManagerRequest(
              service.runReport,
              service,
              this.reportData))
              .do(this.reports[this.selectedReportIndex].Id, params);
      this.columnFormatters = this.reports[this.selectedReportIndex].Columns;
      this.loopReportData();
    },
    loopReportData() {
      this.reportAsArrayOfArrays = [];

      let arrHeaders = Object.keys(Array.isArray(this.reportData) && this.reportData.length > 0 ? this.reportData[0] : {});
      if (arrHeaders.length === 0) {
        return;
      }
      this.reportAsArrayOfArrays.push(arrHeaders.map(el => ReportColumnsCalculation.formatColName(el, this.columnFormatters)));

      if (this.reports[this.selectedReportIndex].Parameters && this.reports[this.selectedReportIndex].Parameters.length > 0) {
        const arrParameters = this.reports[this.selectedReportIndex].Parameters;
        for (let p of arrParameters) {
          let pName  = p.Name;
          let pValue = p.Value;
          this.reportAsArrayOfArrays.push([pName, pValue]);
        }
      }

      let footer = {};
      for (let dbName of arrHeaders) {
        footer[dbName] = null;
      }

      for (let rowReportData of this.reportData) {
        let row = [];
        for (let dbName in rowReportData) {
          if (rowReportData.hasOwnProperty(dbName)) {
            let value = rowReportData[dbName];
            let v     = ReportColumnsCalculation.formatColValue(value, dbName, this.columnFormatters);
            row.push(v)
            if (ReportColumnsCalculation.isFieldInTotals(dbName, this.columnFormatters)) {
              footer[dbName] = footer[dbName] + parseFloat(value);
            }
          }
        }
        this.reportAsArrayOfArrays.push(row);
      }
      let rowFooter = [];
      for (let [dbName, total] of Object.entries(footer)) {
        let t = ReportColumnsCalculation.formatColValue(total, dbName, this.columnFormatters);
        rowFooter.push(t);
      }
      this.reportAsArrayOfArrays.push(rowFooter);
      this.reportData.push(footer);
    }
  },
  components: {
    ParametersTable,
    ReportTable
  }
};
</script>

<style lang="scss" scoped>
  .report-button {
    min-width: 100px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
</style>
